// Clerk sign-in tickets arrive as `/signin#__clerk_ticket=` and `/signin?ticket=`.
const TICKET_PARAM = /([?#&])(__clerk_ticket|ticket)=[^&#\s"']*/g
const HAS_TICKET_PARAM = /[?#&](__clerk_ticket|ticket)=/

export function hasSignInTicket(url: string): boolean {
  return HAS_TICKET_PARAM.test(url)
}

export function scrubTicketUrl(value: string): string {
  return value.replace(TICKET_PARAM, '$1$2=[Filtered]')
}

// Guards against cyclic `extra` data; Sentry normalizes events far shallower than this.
const MAX_DEPTH = 12

function isPlainObject(value: object): value is Record<string, unknown> {
  const proto = Object.getPrototypeOf(value)
  return proto === Object.prototype || proto === null
}

/** Returns the value with sign-in tickets redacted, copying only the objects it changes. */
export function scrubSignInTickets<T>(value: T, depth = 0): T {
  if (typeof value === 'string') {
    return scrubTicketUrl(value) as T
  }
  if (depth >= MAX_DEPTH) {
    return value
  }
  if (Array.isArray(value)) {
    const next = value.map((item) => scrubSignInTickets(item, depth + 1))
    return (next.some((item, i) => item !== value[i]) ? next : value) as T
  }
  if (value === null || typeof value !== 'object' || !isPlainObject(value)) {
    return value
  }
  let copy: Record<string, unknown> | null = null
  for (const [key, item] of Object.entries(value)) {
    const next = scrubSignInTickets(item, depth + 1)
    if (next !== item) {
      copy ??= { ...value }
      copy[key] = next
    }
  }
  return (copy ?? value) as T
}
